import SelectCurrencies from './select-currencies';

export default SelectCurrencies;
